import React from 'react';
import { NavLink } from 'react-router-dom';

const AdminSidebar = ({ onLogout, isOpen = true, onClose }) => {
  const links = [
    { label: 'Dashboard', path: '/admin', icon: '▦', end: true },
    { label: 'Firms', path: '/admin/firms', icon: '▤' },
    { label: 'Create Firm', path: '/admin/firms/create', icon: '+' },
    { label: 'Users', path: '/admin/users', icon: '♙' },
  ];

  return (
    <>
      {isOpen && onClose && (
        <button
          type="button"
          className="admin-sidebar-overlay"
          aria-label="Close navigation"
          onClick={onClose}
        />
      )}

      <aside className={`admin-sidebar ${isOpen ? 'is-open' : ''}`}>
        <div className="admin-sidebar-brand">
          <div className="admin-brand-icon">D</div>
          <div>
            <h2>Distributor CRM</h2>
            <span>Administration</span>
          </div>
        </div>

        <div className="admin-sidebar-section">WORKSPACE</div>

        <nav className="admin-sidebar-nav" aria-label="Admin navigation">
          {links.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              end={link.end}
              className={({ isActive }) =>
                `admin-sidebar-link ${isActive ? 'active' : ''}`
              }
              onClick={onClose}
            >
              <span className="admin-sidebar-link-icon" aria-hidden="true">
                {link.icon}
              </span>
              <span>{link.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-sidebar-user">
            <div className="admin-avatar">SA</div>
            <div className="admin-sidebar-user-info">
              <strong>Super Admin</strong>
              <span>Administrator</span>
            </div>
          </div>

          {onLogout && (
            <button
              type="button"
              className="admin-logout-button"
              onClick={onLogout}
            >
              <span aria-hidden="true">↪</span> Sign out
            </button>
          )}
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;